import { Client } from '../types'

export const CLIENTS: Client[] = [
  {
    id: 'c1',
    name: 'Camila Rodríguez',
    initials: 'CR',
    email: 'camila.r@mail.com',
    phone: '+598 99 123 456',
    city: 'Pocitos, Montevideo',
    joined: 'Marzo 2024',
    orders: 9,
    spent: 28640,
    lastPurchase: '06 ago 2026',
    lastPurchaseIso: '2026-08-06',
    history: [
      {
        id: '#ZD-1042',
        date: '06 ago 2026',
        total: 4280,
        items: 'Banda Elástica Pro ×2, Guantes Grip Black',
        status: 'pendiente',
      },
      {
        id: '#ZD-0988',
        date: '18 jul 2026',
        total: 3290,
        items: 'Kit ZADAR Esencial',
        status: 'entregado',
      },
      {
        id: '#ZD-0902',
        date: '02 jun 2026',
        total: 2190,
        items: 'Tobilleras Ajustables 3kg',
        status: 'entregado',
      },
      {
        id: '#ZD-0844',
        date: '11 may 2026',
        total: 1590,
        items: 'Guantes Grip Black',
        status: 'entregado',
      },
    ],
  },
  {
    id: 'c2',
    name: 'Martín Pereira',
    initials: 'MP',
    email: 'm.pereira@mail.com',
    phone: '+598 98 774 210',
    city: 'Ciudad de la Costa, Canelones',
    joined: 'Enero 2025',
    orders: 4,
    spent: 9180,
    lastPurchase: '06 ago 2026',
    lastPurchaseIso: '2026-08-06',
    history: [
      {
        id: '#ZD-1041',
        date: '06 ago 2026',
        total: 1590,
        items: 'Guantes Grip Black',
        status: 'pendiente',
      },
      {
        id: '#ZD-0961',
        date: '30 jun 2026',
        total: 4490,
        items: 'Kit Glute Builder',
        status: 'entregado',
      },
      {
        id: '#ZD-0877',
        date: '21 abr 2026',
        total: 3100,
        items: 'Faja Lumbar Power, Banda Heavy',
        status: 'entregado',
      },
    ],
  },
  {
    id: 'c3',
    name: 'Lucía Fernández',
    initials: 'LF',
    email: 'lucia.f@mail.com',
    phone: '+598 91 336 902',
    city: 'Punta del Este, Maldonado',
    joined: 'Septiembre 2023',
    orders: 14,
    spent: 41250,
    lastPurchase: '05 ago 2026',
    lastPurchaseIso: '2026-08-05',
    history: [
      {
        id: '#ZD-1040',
        date: '05 ago 2026',
        total: 3290,
        items: 'Kit ZADAR Esencial',
        status: 'proceso',
      },
      {
        id: '#ZD-1002',
        date: '24 jul 2026',
        total: 5980,
        items: 'Corrector Postural Active ×2, Grips',
        status: 'entregado',
      },
      {
        id: '#ZD-0931',
        date: '09 jun 2026',
        total: 1490,
        items: 'Tobilleras Lite 1kg',
        status: 'entregado',
      },
    ],
  },
  {
    id: 'c4',
    name: 'Diego Sosa',
    initials: 'DS',
    email: 'dsosa@mail.com',
    phone: '+598 94 118 507',
    city: 'Salto',
    joined: 'Julio 2025',
    orders: 3,
    spent: 6070,
    lastPurchase: '05 ago 2026',
    lastPurchaseIso: '2026-08-05',
    history: [
      {
        id: '#ZD-1039',
        date: '05 ago 2026',
        total: 2190,
        items: 'Tobilleras Ajustables 3kg',
        status: 'enviado',
      },
      {
        id: '#ZD-0955',
        date: '28 jun 2026',
        total: 2490,
        items: 'Corrector Postural Active',
        status: 'entregado',
      },
      {
        id: '#ZD-0910',
        date: '15 may 2026',
        total: 1390,
        items: 'Guantes Mesh Flex',
        status: 'entregado',
      },
    ],
  },
  {
    id: 'c5',
    name: 'Valentina Cabrera',
    initials: 'VC',
    email: 'valen.c@mail.com',
    phone: '+598 92 640 118',
    city: 'Carrasco, Montevideo',
    joined: 'Febrero 2024',
    orders: 11,
    spent: 33980,
    lastPurchase: '04 ago 2026',
    lastPurchaseIso: '2026-08-04',
    history: [
      {
        id: '#ZD-1038',
        date: '04 ago 2026',
        total: 6480,
        items: 'Kit Glute Builder, Banda Heavy',
        status: 'enviado',
      },
      {
        id: '#ZD-0994',
        date: '20 jul 2026',
        total: 990,
        items: 'Banda Elástica Pro',
        status: 'entregado',
      },
      {
        id: '#ZD-0921',
        date: '01 jun 2026',
        total: 2790,
        items: 'Faja Lumbar Power',
        status: 'entregado',
      },
    ],
  },
  {
    id: 'c6',
    name: 'Rodrigo Méndez',
    initials: 'RM',
    email: 'rodri.mendez@mail.com',
    phone: '+598 97 205 443',
    city: 'Colonia del Sacramento',
    joined: 'Mayo 2026',
    orders: 2,
    spent: 2480,
    lastPurchase: '03 ago 2026',
    lastPurchaseIso: '2026-08-03',
    history: [
      {
        id: '#ZD-1037',
        date: '03 ago 2026',
        total: 990,
        items: 'Banda Elástica Pro',
        status: 'entregado',
      },
      {
        id: '#ZD-0972',
        date: '08 jul 2026',
        total: 1490,
        items: 'Tobilleras Lite 1kg',
        status: 'entregado',
      },
    ],
  },
  {
    id: 'c7',
    name: 'Sofía Olivera',
    initials: 'SO',
    email: 'sofia.olivera@mail.com',
    phone: '+598 99 887 001',
    city: 'Paysandú',
    joined: 'Noviembre 2024',
    orders: 7,
    spent: 18420,
    lastPurchase: '02 ago 2026',
    lastPurchaseIso: '2026-08-02',
    history: [
      {
        id: '#ZD-1036',
        date: '02 ago 2026',
        total: 3980,
        items: 'Guantes Grip Black, Corrector Postural',
        status: 'entregado',
      },
      {
        id: '#ZD-0940',
        date: '14 jun 2026',
        total: 1890,
        items: 'Grips Competition',
        status: 'entregado',
      },
    ],
  },
  {
    id: 'c8',
    name: 'Nicolás Varela',
    initials: 'NV',
    email: 'nvarela@mail.com',
    phone: '+598 96 512 337',
    city: 'Rivera',
    joined: 'Abril 2026',
    orders: 1,
    spent: 1490,
    lastPurchase: '01 ago 2026',
    lastPurchaseIso: '2026-08-01',
    history: [
      {
        id: '#ZD-1035',
        date: '01 ago 2026',
        total: 1490,
        items: 'Banda Elástica Heavy',
        status: 'entregado',
      },
    ],
  },
  {
    id: 'c9',
    name: 'Florencia Bentancor',
    initials: 'FB',
    email: 'flor.bentancor@mail.com',
    phone: '+598 93 442 786',
    city: 'Tacuarembó',
    joined: 'Agosto 2025',
    orders: 5,
    spent: 12310,
    lastPurchase: '12 jul 2026',
    lastPurchaseIso: '2026-07-12',
    history: [
      {
        id: '#ZD-0981',
        date: '12 jul 2026',
        total: 3290,
        items: 'Kit ZADAR Esencial',
        status: 'entregado',
      },
      {
        id: '#ZD-0904',
        date: '19 may 2026',
        total: 1190,
        items: 'Soga Speed Rope',
        status: 'entregado',
      },
    ],
  },
  {
    id: 'c10',
    name: 'Joaquín Silva',
    initials: 'JS',
    email: 'joaquin.silva@mail.com',
    phone: '+598 95 019 664',
    city: 'Malvín, Montevideo',
    joined: 'Junio 2024',
    orders: 6,
    spent: 15740,
    lastPurchase: '28 jun 2026',
    lastPurchaseIso: '2026-06-28',
    history: [
      {
        id: '#ZD-0958',
        date: '28 jun 2026',
        total: 4490,
        items: 'Kit Glute Builder',
        status: 'entregado',
      },
      {
        id: '#ZD-0890',
        date: '02 may 2026',
        total: 1590,
        items: 'Guantes Grip Black',
        status: 'entregado',
      },
    ],
  },
]
